import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, LogIn, LogOut } from "lucide-react";
import { Button } from "./ui/button";
import API_BASE_URL from "../config";
import "./Header.css";

export const Header = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const API_BASE = `${API_BASE_URL}/auth`;

  // Проверка авторизации через API
  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/check`, {
        credentials: 'include' // Важно: отправляем cookies
      });
      const data = await res.json();
      setIsAuthenticated(data.authenticated || false);
    } catch (err) {
      console.error("Auth check failed:", err);
      setIsAuthenticated(false);
    }
  }, [API_BASE]);

  useEffect(() => {
    checkAuth();
    
    // Слушаем изменения в текущей вкладке через кастомное событие
    window.addEventListener("authChange", checkAuth);

    return () => {
      window.removeEventListener("authChange", checkAuth);
    };
  }, [checkAuth]);

  const handleAuthClick = async () => {
    if (isAuthenticated) {
      // Выход из системы через API
      try {
        await fetch(`${API_BASE}/logout`, {
          method: "POST",
          credentials: 'include' // Важно: отправляем cookies
        });
        // Отправляем событие для обновления состояния в других компонентах
        window.dispatchEvent(new Event("authChange"));
        setIsAuthenticated(false);
      } catch (err) {
        console.error("Logout failed:", err);
      }
    } else {
      // Переход на страницу авторизации
      navigate("/auth");
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <Button
            variant="ghost"
            size="icon"
            className="header-burger"
            onClick={() => window.dispatchEvent(new Event("sidebarToggle"))}
          >
            <Menu className="header-burger-icon" />
          </Button>

          <div className="header-brand">
            <img src="/logo.png" alt="SoliditySet Logo" className="header-icon" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
            <span className="header-title">
              SoliditySet
            </span>
          </div>
        </div>
        
        <div className="header-actions">
          <Button 
            variant="ghost" 
            size="icon"
            className="header-button-signin"
            onClick={handleAuthClick}
            title={isAuthenticated ? "Sign Out" : "Sign In"}
          >
            {isAuthenticated ? (
              <LogOut className="header-auth-icon" />
            ) : (
              <LogIn className="header-auth-icon" />
            )}
          </Button>
        </div>
      </div>
    </header>
  );
};

